export function randInt(low: number, high: number): number {
  return low + Math.floor(Math.random() * (high - low + 1));
}

export function remap(
  x: number,
  [low1, high1]: [number, number],
  [low2, high2]: [number, number],
  clamp = true
): number {
  // Avoid division by zero if the domain is zero-size
  if (low1 === high1) {
    return low2; // or throw an error, depending on your needs
  }

  // Compute the ratio of how far x sits along [low1, high1]
  const ratio = (x - low1) / (high1 - low1);
  // Project ratio into [low2, high2]
  let result = low2 + ratio * (high2 - low2);

  // Optionally clamp the result into the target range
  if (clamp) {
    if (low2 < high2) {
      result = Math.min(Math.max(result, low2), high2);
    } else {
      result = Math.max(Math.min(result, low2), high2);
    }
  }

  return result;
}
